module.exports = __webpack_public_path__ + "media/recipes/10-0aeb6e0c.png";